import React, { FunctionComponent } from 'react'
import style from './style.scss'

type IProps = {
  href?: string
}

const TopBarButton: FunctionComponent<IProps> = ({children, href}) => {
  if (href) {
    return <a className={style.topBarButton} href={href}>{children}</a>
  }

  return <div className={style.topBarButton}>{children}</div>
}

export default TopBarButton
